<template>
  <div>
    <!--Stats cards-->
    <div class="row">
      <div
        class="col-md-6 col-xl-3"
        v-for="stats in statsCards"
        :key="stats.title"
      >
        <stats-card>
          <div
            class="icon-big text-center"
            :class="`icon-${stats.type}`"
            slot="header"
          >
            <i :class="stats.icon"></i>
          </div>
          <div class="numbers" slot="content">
            <p>{{ stats.title }}</p>
            {{ stats.value }}
          </div>
          <div class="stats" slot="footer">
            <i :class="stats.footerIcon"></i> {{ stats.footerText }}
          </div>
        </stats-card>
      </div>
    </div>

    <!--Charts-->
    <div class="row">
      <div
        v-for="point in points.base1"
        :key="point.type"
        class="col-md-6 col-12"
      >
        <chart-card
          :title="`Pontos ${point.type}`"
          :sub-title="`${
            point.total
          } pontos ${point.type.toLowerCase()} no total`"
          :chart-data="point.chartData"
          :chart-options="{ distributeSeries: true }"
          :chart-type="point.chartType"
        >
          <span slot="footer">
            <i class="fa fa-clock-o"></i>Atualizado
            {{ lastUpdateDistance }}</span
          >
          <div slot="legend">
            <div v-for="label in point.labels" :key="label.name">
              <i :class="`fa fa-circle text-${label.color}`"></i>
              {{ label.name }} ({{ label.total }})
            </div>
          </div>
        </chart-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import swal from "sweetalert2";
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import { StatsCard, ChartCard } from "@/components/index";

export default {
  components: {
    StatsCard,
    ChartCard,
  },
  computed: mapState(["points"]),
  data() {
    return {
      statsCards: [],
      lastUpdateAt: new Date(),
      lastUpdateDistance: "há menos de um minuto",
    };
  },
  methods: {
    ...mapActions(["fetchBase1"]),
    lastUpdateAtDistance() {
      this.lastUpdateDistance = formatDistance(this.lastUpdateAt, new Date(), {
        locale: pt,
        addSuffix: true,
      });
    },
  },
  async mounted() {
    try {
      await this.fetchBase1();
    } catch (e) {
      console.error(e);
      swal.fire("Ops!", "Não foi possível carregar os dados!", "error");
    }

    setInterval(() => {
      this.lastUpdateAtDistance();
    }, 60000);
  },
};
</script>

<style>
</style>
